import { useEffect, useState } from "react";
import { useAppSelector } from "../../../../store/hooks";
import { CartItems, CartItemsMap, Options } from "../../../../store/types";
import { Box, Grid, Typography } from "@material-ui/core";
import { useHistory, useLocation } from "react-router-dom";
import { InvestorHeader } from "../InvestorCart";
import { AmcHeader, NewPurchaseSummary } from "../CartItems";
import { Form, Formik, FormikProps } from "formik";
import GridContainer from "../../../../lib/GridContainer";
import FormRadioButton from "../../../forms/formik/FormRadioField";
import FormSelect from "../../../forms/formik/FormSelectField";
import SubmitButton from "../../../forms/formik/FormSubmitButton";
import { useDispatch } from "react-redux";

import {
  UmrnOptions,
  checkAotmStatus,
  checkoutNewPurchase,
  getAmcMasters,
  getPaymentOptions,
  getUmrnList,
  newPurchase,
} from "../../../../store/actions";
import {
  handleError,
  isValidMandateFilterLumpsum,
} from "../../../../utils/cart";

import * as Yup from "yup";
import UmrnDetails from "../../../common/umrn-details";

export function NewPurchaseCart() {
  // @ts-ignore
  const cartItems: CartItems<"NPL"> = useAppSelector(
    ({ cartReducer }) => cartReducer.cartItems
  );

  const dispatch = useDispatch();
  const { state } = useLocation<CartLocation>();
  const history = useHistory();

  const [umrnOptions, setUmrnOptions] = useState<UmrnOptions>([]);
  const [amcList, setAmcList] = useState<Options>([]);
  const [paymentOptions, setPaymentOptions] = useState<Options>([]);

  const { requestBody } = state;

  const { selectedCartItems: selectedItems } = requestBody;

  const selectedCartItems = cartItems.filter((item) =>
    selectedItems.includes(item.cartItemId)
  );

  async function onSubmit(values: Values) {
    try {
      const { paymentMode, umrn } = values;
      const selectedMandateDetails = umrnOptions.find(
        ({ value }) => value === umrn
      );
      const paymentBody = {
        ...requestBody,
        paymentDetails: {
          paymentMode,
        },
        createMandate: false,
        umrn: paymentMode.includes("OTM") ? umrn : "",
        selectedMandates: selectedMandateDetails,
        euin: cartItems[0].payload.euin,
        subBroker: cartItems[0].payload.subBroker,
        subArn: cartItems[0].payload.subArn,
      };
      const response = await checkoutNewPurchase(paymentBody)(dispatch);
      if (response) {
        const { batchId } = response;
        const message = `Transaction submitted successfully with batch number ${batchId}`;
        alert(message);
        history.replace("/investors");
      }
    } catch (error) {
      handleError(error);
    }
  }

  useEffect(() => {
    async function fetchUmrn() {
      try {
        const response = await getPaymentOptions(
          cartItems[0].fund,
          "NPL"
        )(dispatch);
        const isPanBasedOtm = await checkAotmStatus(cartItems[0].fund)(
          dispatch
        );

        setPaymentOptions(
          response.filter(({ value }) => {
            if (isPanBasedOtm) return true;
            return value !== "AOTM";
          })
        );
      } catch (error) {
        handleError(error);
      }
    }
    fetchUmrn();
  }, [cartItems, dispatch]);

  useEffect(() => {
    async function fetchFundsList() {
      setAmcList(await getAmcMasters()(dispatch));
    }
    fetchFundsList();
  }, [dispatch]);

  const getUmrnOptions: HandleChange = function (
    values,
    { setFieldError, setFieldValue }
  ) {
    return async function (selectedPaymode) {
      try {
        if (!selectedPaymode.includes("OTM")) {
          setFieldValue("paymentMode", selectedPaymode);
          return;
        }

        const response = await getUmrnList({
          fund: cartItems[0].fund,
          pan: cartItems[0].pan,
          folio: 0,
          modeOfRegistration: selectedPaymode,
        })(dispatch);
        const highestAmount = Math.max(
          ...selectedCartItems.map((i) => i.payload.amount).map(Number)
        );
        const filteredMandates = response.filter(
          isValidMandateFilterLumpsum(highestAmount)
        );
        setUmrnOptions(filteredMandates);
        if (filteredMandates.length === 0) {
          throw new Error(
            "There are no valid mandates available, please select a different payment mode"
          );
        }
        setFieldValue("paymentMode", selectedPaymode);
      } catch (error) {
        if (error instanceof Error) {
          setFieldError("paymentMode", error.message);
        }
        handleError(error);
      }
    };
  };

  return (
    <Grid container>
      <Grid item lg={9} sm={12}>
        <InvestorHeader
          name={selectedCartItems[0].investorName}
          pan={cartItems[0].pan}
        />

        <Box
          sx={{
            margin: "40px",
            bgcolor: "white",
            padding: "18px 24px 18px 24px",
            boxShadow: "0px 0px 8px 0px rgba(202, 202, 202, 1);",
            borderRadius: "4px",
            marginBottom: "120px",
          }}
        >
          <Typography
            component={"h4"}
            style={{
              fontWeight: "800",
              fontSize: "24px",
              marginBottom: "20px",
              fontFamily: "OpenSans-SemiBold",
            }}
          >
            New Purchase
          </Typography>

          <AmcHeader
            amcName={
              amcList.find(({ value }) => value === cartItems[0].fund)?.label
            }
          />

          <Box
            sx={{
              padding: "10px",
              border: "0.5px solid #C7D2D4",
            }}
          >
            {selectedCartItems.map((item) => (
              <NewPurchaseSummary {...item.payload} key={item.ihno} />
            ))}
          </Box>
          <Formik<Values>
            initialValues={{
              paymentMode: "NETBANKING",
              umrn: "",
            }}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {({ values, ...formikHelpers }) => {
              console.log(values, "values--->");
              return (
                <Form>
                  <GridContainer>
                    <FormRadioButton
                      name="paymentMode"
                      label="Payment Mode"
                      options={paymentOptions}
                      onChange={getUmrnOptions(values, formikHelpers)}
                    />
                  </GridContainer>
                  {values.paymentMode.includes("OTM") &&
                  umrnOptions.length > 0 ? (
                    <GridContainer>
                      <FormSelect
                        options={umrnOptions}
                        label="Select Mandate"
                        name="umrn"
                      />
                    </GridContainer>
                  ) : null}
                  {values.paymentMode.includes("OTM") && values.umrn ? (
                    <UmrnDetails
                      {...umrnOptions.find((v) => v.value === values.umrn)}
                    />
                  ) : null}
                  <SubmitButton label="Save and Proceed" />
                </Form>
              );
            }}
          </Formik>
        </Box>
      </Grid>
    </Grid>
  );
}

export function NewPurchaseSingle() {
  const location = useLocation<SingleLocation>();
  const dispatch = useDispatch();
  const history = useHistory();

  const [umrnOptions, setUmrnOptions] = useState<UmrnOptions>([]);
  const [amcList, setAmcList] = useState<Options>([]);
  const [paymentOptions, setPaymentOptions] = useState<Options>([]);

  const { requestBody } = location.state;

  useEffect(() => {
    async function fetchUmrn() {
      try {
        const response = await getPaymentOptions(
          requestBody.fund,
          "NPL"
        )(dispatch);
        const isPanBasedOtm = await checkAotmStatus(requestBody.fund)(dispatch);
        setPaymentOptions(
          response.filter(({ value }) => {
            if (isPanBasedOtm) return true;
            return value !== "AOTM";
          })
        );
      } catch (error) {
        handleError(error);
      }
    }

    fetchUmrn();
  }, [dispatch, requestBody]);

  useEffect(() => {
    async function fetchFundsList() {
      setAmcList(await getAmcMasters()(dispatch));
    }
    fetchFundsList();
  }, [dispatch]);

  async function onSubmit(values: Values) {
    try {
      const { paymentMode, umrn } = values;
      const selectedMandateDetails = umrnOptions.find(
        ({ value }) => value === umrn
      );

      const paymentBody = {
        ...requestBody,
        paymentMode,
        createMandate: false,
        umrn: paymentMode.includes("OTM") ? umrn : "",
        selectedMandates: selectedMandateDetails,
      };

      const response = await newPurchase(paymentBody)(dispatch);
      if (response) {
        history.replace("/investors");
      }
    } catch (error) {
      handleError(error);
    }
  }
  const getUmrnOptions: HandleChange = function (
    values,
    { setFieldError, setFieldValue }
  ) {
    return async function (selectedPaymode) {
      try {
        setUmrnOptions([]);
        if (!selectedPaymode.includes("OTM")) {
          setFieldValue("paymentMode", selectedPaymode);
          return;
        }
        const response = await getUmrnList({
          fund: requestBody.fund,
          pan: requestBody.pan,
          folio: 0,
          modeOfRegistration: selectedPaymode,
        })(dispatch);

        const highestAmount = Number(requestBody.amount);
        const filteredMandates = response.filter(
          isValidMandateFilterLumpsum(highestAmount)
        );
        setUmrnOptions(filteredMandates);
        if (filteredMandates.length === 0) {
          throw new Error(
            "There are no valid mandates available, please select a different payment mode"
          );
        }

        setFieldValue("paymentMode", selectedPaymode);
      } catch (error) {
        if (error instanceof Error) {
          setFieldError("paymentMode", error.message);
        }
        handleError(error);
      }
    };
  };

  return (
    <Grid container>
      <Grid item lg={9} sm={12}>
        <InvestorHeader name={requestBody.investorName} pan={requestBody.pan} />
        <Box
          sx={{
            margin: "40px",
            bgcolor: "white",
            padding: "18px 24px 18px 24px",
            boxShadow: "0px 0px 8px 0px rgba(202, 202, 202, 1);",
            borderRadius: "4px",
            marginBottom: "120px",
          }}
        >
          <Typography
            component={"h4"}
            style={{
              fontWeight: "800",
              fontSize: "24px",
              marginBottom: "20px",
              fontFamily: "OpenSans-SemiBold",
            }}
          >
            New Purchase
          </Typography>

          <AmcHeader
            amcName={
              amcList.find(({ value }) => value === requestBody.fund)?.label
            }
          />

          <Box
            sx={{
              padding: "10px",
              border: "0.5px solid #C7D2D4",
            }}
          >
            <NewPurchaseSummary {...requestBody} />
          </Box>
          <Formik<Values>
            initialValues={{
              paymentMode: "NETBANKING",
              umrn: "",
            }}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {({ values, ...formikHelpers }) => (
              <Form>
                <GridContainer>
                  <FormRadioButton
                    name="paymentMode"
                    label="Payment Mode"
                    options={paymentOptions}
                    onChange={getUmrnOptions(values, formikHelpers)}
                  />
                </GridContainer>

                {values.paymentMode.includes("OTM") &&
                umrnOptions.length > 0 ? (
                  <GridContainer>
                    <FormSelect
                      options={umrnOptions}
                      label="Select Mandate"
                      name="umrn"
                    />
                  </GridContainer>
                ) : null}
                {values.paymentMode.includes("OTM") && values.umrn ? (
                  <UmrnDetails
                    {...umrnOptions.find((v) => v.value === values.umrn)}
                  />
                ) : null}
                <SubmitButton label="Save and Proceed" />
              </Form>
            )}
          </Formik>
        </Box>
      </Grid>
    </Grid>
  );
}

const { string, object } = Yup;

const validationSchema = object().shape({
  paymentMode: string().required("Please select payment mode").nullable(),
  umrn: string().when("paymentMode", {
    is: "KOTM",
    then: string().required("Please select UMRN"),
    otherwise: string().notRequired(),
  }),
});

interface Values {
  paymentMode: "KOTM" | "UPI" | "NETBANKING";
  umrn: string;
}

interface CartLocation {
  requestBody: {
    selectedCartItems: Array<string>;
    pan: string;
    arnCode: string;
    cartId: string;
  };
}

interface SingleLocation {
  requestBody: CartItemsMap["NPL"];
}
type HandleChange = (
  values: Values,
  args: Omit<FormikProps<Values>, "values">
) => (newSelection: any) => any;
